// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Custom Properties for Theming */
:root[data-theme="light"] {
  /* Background Colors */
  --bg-primary: #FFFFFF;
  --bg-secondary: #F9FAFB;
  --bg-tertiary: #F3F4F6;
  --bg-gradient: linear-gradient(135deg, #EFF6FF 0%, #FFFFFF 50%, #F3E8FF 100%);
  
  /* Text Colors */
  --text-primary: #111827;
  --text-secondary: #6B7280;
  --text-tertiary: #9CA3AF;
  --text-accent: #374151;
  
  /* Border Colors */
  --border-primary: #E5E7EB;
  --border-secondary: #D1D5DB;
  --border-tertiary: #F3F4F6;
  
  /* Accent Colors */
  --accent-primary: #6366F1;
  --accent-secondary: #8B5CF6;
  --accent-gradient: linear-gradient(135deg, #6366F1, #8B5CF6);
  
  /* Shadow Colors */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  
  /* Feature Colors */
  --feature-bg: #EFF6FF;
  --feature-icon-color: #6366F1;
  
  /* Error Colors */
  --error-bg: #FEF2F2;
  --error-border: #FECACA;
  --error-text: #DC2626;
  
  /* Input Colors */
  --input-bg: #FFFFFF;
  --input-border: #D1D5DB;
  --input-focus: #6366F1;
  --input-focus-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

:root[data-theme="dark"] {
  /* Background Colors */
  --bg-primary: #1F2937;
  --bg-secondary: #111827;
  --bg-tertiary: #374151;
  --bg-gradient: linear-gradient(135deg, #1F2937 0%, #111827 50%, #374151 100%);
  
  /* Text Colors */
  --text-primary: #F9FAFB;
  --text-secondary: #D1D5DB;
  --text-tertiary: #9CA3AF;
  --text-accent: #E5E7EB;
  
  /* Border Colors */
  --border-primary: #374151;
  --border-secondary: #4B5563;
  --border-tertiary: #6B7280;
  
  /* Accent Colors */
  --accent-primary: #818CF8;
  --accent-secondary: #A78BFA;
  --accent-gradient: linear-gradient(135deg, #818CF8, #A78BFA);
  
  /* Shadow Colors */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.3);
  --shadow-xl: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  
  /* Feature Colors */
  --feature-bg: #374151;
  --feature-icon-color: #818CF8;
  
  /* Error Colors */
  --error-bg: #7F1D1D;
  --error-border: #DC2626;
  --error-text: #FCA5A5;
  
  /* Input Colors */
  --input-bg: #374151;
  --input-border: #4B5563;
  --input-focus: #818CF8;
  --input-focus-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2);
}

/* Theme Toggle Button */
.theme-toggle {
  padding: 10px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.theme-toggle:hover {
  background: var(--bg-secondary);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.theme-icon {
  width: 20px;
  height: 20px;
}

/* Homepage Styles */
.homepage {
  min-height: 100vh;
  background: var(--bg-gradient);
}

.header {
  background-color: var(--bg-primary);
  box-shadow: var(--shadow-sm);
  border-bottom: 1px solid var(--border-primary);
}

.header-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-container {
  width: 40px;
  height: 40px;
  background: var(--accent-gradient);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-icon {
  width: 24px;
  height: 24px;
  color: #FFFFFF;
}

.logo-title {
  font-size: 20px;
  font-weight: bold;
  color: var(--text-primary);
  margin: 0;
}

.logo-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
}

.main {
  max-width: 1280px;
  margin: 0 auto;
  padding: 64px 24px;
}

.hero-section {
  text-align: center;
  margin-bottom: 64px;
}

.hero-title {
  font-size: 48px;
  font-weight: bold;
  color: var(--text-primary);
  margin-bottom: 24px;
  line-height: 1.1;
}

.hero-highlight {
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 20px;
  color: var(--text-secondary);
  max-width: 768px;
  margin: 0 auto 32px auto;
  line-height: 1.6;
}

/* CTA Button */
.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: var(--accent-gradient);
  color: #FFFFFF;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  text-decoration: none;
}

.cta-button:hover {
  transform: scale(1.05);
}

.cta-icon {
  width: 24px;
  height: 24px;
}

.cta-arrow {
  width: 20px;
  height: 20px;
}

/* Advisors Grid */
.advisors-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 64px;
}

.advisor-card {
  background-color: var(--bg-primary);
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-primary);
  text-align: center;
  transition: all 0.3s ease;
}

.advisor-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
}

.advisor-card-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
}

.advisor-card-icon svg {
  width: 32px;
  height: 32px;
}

.advisor-card-title {
  font-size: 24px;
  font-weight: bold;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.advisor-card-role {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
}

.advisor-card-description {
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

/* Features Section */
.features-section {
  margin-bottom: 64px;
}

.features-title {
  font-size: 32px;
  font-weight: bold;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 48px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.feature-card {
  text-align: center;
  padding: 24px;
}

.feature-icon {
  width: 64px;
  height: 64px;
  background-color: var(--feature-bg);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
}

.feature-icon svg {
  width: 32px;
  height: 32px;
  color: var(--feature-icon-color);
}

.feature-title {
  font-size: 20px;
  font-weight: bold;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.feature-description {
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

/* Suggestions Panel */
.suggestions-panel {
  padding: 32px 0;
  max-width: 900px;
  margin: 0 auto;
}

.suggestions-header {
  text-align: center;
  margin-bottom: 32px;
}

.suggestions-title {
  font-size: 28px;
  font-weight: bold;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.suggestions-subtitle {
  font-size: 16px;
  color: var(--text-secondary);
  margin: 0;
}

.suggestions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.suggestion-category {
  background-color: var(--bg-primary);
  border-radius: 12px;
  border: 1px solid var(--border-primary);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  transition: box-shadow 0.2s ease;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.suggestion-category:hover {
  box-shadow: var(--shadow-md);
}

.category-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-tertiary);
}

.category-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.category-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.suggestion-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
}

.suggestion-button {
  text-align: left;
  padding: 12px 16px;
  border: 1px solid var(--border-secondary);
  border-radius: 8px;
  background-color: transparent;
  color: var(--text-accent);
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  transition: all 0.2s ease;
}

.suggestion-button:hover {
  background-color: var(--hover-bg, var(--bg-secondary));
  border-color: var(--hover-border, var(--accent-primary));
  color: var(--hover-text, var(--text-primary));
  transform: translateY(-1px);
}

/* Message Components */
.user-message-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.user-message {
  background: var(--accent-gradient);
  color: #FFFFFF;
  border-radius: 16px;
  padding: 12px 24px;
  max-width: 384px;
}

.user-message p {
  margin: 0;
}

.reply-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding: 4px 8px;
  background-color: var(--bg-tertiary);
  border-radius: 8px;
  font-size: 12px;
  color: var(--text-secondary);
}

.advisor-message-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.advisor-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.advisor-avatar svg {
  width: 20px;
  height: 20px;
}

.advisor-message-bubble {
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  border: 1px solid;
  padding: 16px;
  max-width: 512px;
  transition: all 0.2s ease;
}

.advisor-message-bubble.clickable:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.advisor-message-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.advisor-message-name {
  font-weight: 500;
  font-size: 14px;
}

.reply-badge {
  font-size: 10px;
  background: var(--accent-primary);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 4px;
}

.message-time {
  font-size: 12px;
}

.advisor-message-text {
  line-height: 1.6;
}

.advisor-message-text > div:last-child p:last-child {
  margin-bottom: 0; /* Remove bottom margin from last paragraph */
}

.advisor-message-text strong {
  font-weight: 600;
}

.advisor-message-text em {
  font-style: italic;
}

.advisor-message-text ul,
.advisor-message-text ol {
  margin: 0.75rem 0;
  padding-left: 1.5rem;
}

.advisor-message-text li {
  margin-bottom: 0.25rem;
}

.advisor-message-text p {
  margin-bottom: 0.75rem;
}

.advisor-message-text p:last-child {
  margin-bottom: 0;
}


/* Updated Message Actions Styles */
.message-actions {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-tertiary);
}

.message-action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.message-action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: 1px solid;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.message-action-button:hover {
  background: var(--bg-secondary);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.message-action-button:active {
  transform: translateY(0);
}

.message-action-button svg {
  width: 14px;
  height: 14px;
  color: inherit;
}

/* Tooltip Styles */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 6px 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  opacity: 0;
  animation: tooltipFadeIn 0.2s ease-out forwards;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: var(--border-secondary);
}

.tooltip::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: -1px;
  border: 4px solid transparent;
  border-top-color: var(--bg-primary);
}

/* Tooltip Animation */
@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Dark theme tooltip adjustments */
[data-theme="dark"] .tooltip {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Focus states for accessibility */
.message-action-button:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* Copy button success state */
.message-action-button.copied {
  color: #10B981 !important;
  border-color: #10B98140 !important;
}

.reply-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: 1px solid;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reply-button:hover {
  background: var(--bg-secondary);
}

/* Error Messages */
.error-message-container {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.error-message {
  background-color: var(--error-bg);
  border: 1px solid var(--error-border);
  color: var(--error-text);
  border-radius: 12px;
  padding: 12px 16px;
  max-width: 384px;
}

.error-message p {
  margin: 0;
}

/* Thinking Indicators */
.thinking-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  opacity: 0.8;
}

.thinking-bubble {
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  border: 1px solid;
  padding: 16px;
  max-width: 288px;
}

.thinking-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.advisor-name {
  font-weight: 500;
  font-size: 14px;
  margin: 0;
}

.thinking-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-style: italic;
  margin-bottom: 8px;
}

.thinking-dots {
  display: flex;
  gap: 4px;
}

.thinking-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite both;
}

.thinking-text {
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 0;
}

/* Basic Chat Input - SCOPED TO AVOID CONFLICTS */
.input-area {
  border-top: 1px solid var(--border-primary);
  padding: 16px;
}

.input-container {
  display: flex;
  gap: 16px;
}

.message-input {
  flex: 1 1;
  resize: none;
  border: 1px solid var(--input-border);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s ease;
  background-color: var(--input-bg);
  color: var(--text-primary);
}

.message-input::placeholder {
  color: var(--text-secondary);
}

.message-input:focus {
  border-color: var(--input-focus);
  box-shadow: var(--input-focus-shadow);
}

/* IMPORTANT: Make send button styles specific to basic ChatInput only */
.input-container .send-button {
  background: var(--accent-gradient);
  color: #FFFFFF;
  padding: 12px 24px;
  border-radius: 12px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.input-container .send-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.input-container .send-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.input-container .send-icon {
  width: 20px;
  height: 20px;
}

.input-container .send-text {
  display: none;
}

/* Footer Styles */
.footer {
  background-color: var(--bg-primary);
  border-top: 1px solid var(--border-primary);
  margin-top: auto;
}

.footer-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px;
  text-align: center;
}

.footer-text {
  color: var(--text-secondary);
  font-size: 14px;
  margin: 0;
}

.footer-neon-link {
  color: var(--text-secondary);
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.footer-neon-link:hover {
  opacity: 0.8;
}

.footer-neon-logo {
  height: 1em;
  width: auto;
  vertical-align: text-bottom;
  margin-right: 2px;
}

.footer-patents-link {
  color: var(--text-secondary);
  text-decoration: underline;
  transition: opacity 0.2s ease;
}

.footer-patents-link:hover {
  opacity: 0.8;
}

.rag-info-overlay {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  width: 320px;
  max-width: 90vw;
  border: 1px solid;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  margin-top: 8px;
  backdrop-filter: blur(10px);
  animation: ragOverlaySlideIn 0.2s ease-out;
}

@keyframes ragOverlaySlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.rag-overlay-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
  border-radius: 8px 8px 0 0;
}

.rag-overlay-content {
  padding: 16px;
  max-height: 400px;
  overflow-y: auto;
}

.rag-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-secondary);
}

.rag-stat-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.rag-stat-label {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
}

.rag-stat-value {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.rag-stat-value.positive {
  color: #10B981;
}

.rag-stat-value.negative {
  color: #6B7280;
}

.rag-documents-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border-secondary);
}

.rag-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.rag-document-item {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-secondary);
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
}

.rag-document-item:last-child {
  margin-bottom: 0;
}

.rag-document-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.rag-filename {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1 1;
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rag-relevance {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 600;
  color: var(--accent-color);
  background: var(--accent-color)15;
  padding: 2px 6px;
  border-radius: 10px;
  white-space: nowrap;
}

.rag-chunk-preview {
  font-size: 11px;
  line-height: 1.4;
  color: var(--text-tertiary);
  background: var(--bg-quaternary);
  padding: 6px 8px;
  border-radius: 4px;
  border-left: 2px solid var(--accent-color);
  margin-top: 6px;
}

.rag-no-documents {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: var(--bg-secondary);
  border: 1px dashed var(--border-secondary);
  border-radius: 6px;
  color: var(--text-secondary);
  font-size: 12px;
  font-style: italic;
  margin-top: 8px;
}

/* Accessibility improvements */
.rag-info-overlay:focus-within {
  outline: 2px solid var(--accent-color);
  outline-offset: 2px;
}

/* Smooth transitions */
.message-action-button {
  transition: all 0.2s ease;
}

.message-action-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Custom scrollbar for overlay content */
.rag-overlay-content::-webkit-scrollbar {
  width: 4px;
}

.rag-overlay-content::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 2px;
}

.rag-overlay-content::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 2px;
}

.rag-overlay-content::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}

/* Dark theme adjustments */
[data-theme="dark"] .rag-info-overlay {
  background: #1f2937;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
}

[data-theme="dark"] .rag-overlay-header {
  background: #374151;
}

[data-theme="dark"] .rag-document-item {
  background: #374151;
  border-color: #4B5563;
}

[data-theme="dark"] .rag-chunk-preview {
  background: #4B5563;
  color: #D1D5DB;
}

[data-theme="dark"] .rag-no-documents {
  background: #374151;
  border-color: #4B5563;
}

/* Animations */
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .suggestions-panel {
    padding: 24px 16px;
  }
  
  .suggestion-category {
    padding: 18px;
    min-height: 180px;
  }
}

@media (max-width: 768px) {
  .suggestions-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .suggestions-panel {
    padding: 24px 16px;
  }
  
  .suggestions-title {
    font-size: 24px;
  }
  
  .suggestion-category {
    padding: 16px;
    min-height: auto;
  }
  
  .suggestion-button {
    padding: 10px 14px;
    font-size: 13px;
  }

  .advisor-message-text {
    font-size: 14px;
  }

  /* Basic ChatInput mobile styles */
  .input-container .send-text {
    display: inline;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 18px;
  }

  .advisors-grid {
    grid-template-columns: 1fr;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

    .message-action-buttons {
    gap: 6px;
  }

  .message-action-button {
    width: 28px;
    height: 28px;
  }

  .tooltip {
    font-size: 11px;
    padding: 4px 8px;
  }

  .rag-info-overlay {
    width: 280px;
    left: 0;
    right: auto;
  }
  
  .rag-document-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .rag-filename {
    margin-right: 0;
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,6EAA6E;;EAE7E,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;;EAEtB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,4DAA4D;;EAE5D,kBAAkB;EAClB,yCAAyC;EACzC,gDAAgD;EAChD,gDAAgD;EAChD,kDAAkD;;EAElD,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;;EAE7B,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;;EAErB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,6EAA6E;;EAE7E,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;;EAEtB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,4DAA4D;;EAE5D,kBAAkB;EAClB,yCAAyC;EACzC,gDAAgD;EAChD,gDAAgD;EAChD,iDAAiD;;EAEjD,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;;EAE7B,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;;EAErB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,wDAAwD;EACxD,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,mCAAmC;AACnC;EACE,yCAAyC;AAC3C;;AAEA,mCAAmC;AACnC;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,wEAAwE;AACxE;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;IAEE;IACA,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,OAAO;IACP,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;EACxB;;AAEF","sourcesContent":["/* CSS Custom Properties for Theming */\n:root[data-theme=\"light\"] {\n  /* Background Colors */\n  --bg-primary: #FFFFFF;\n  --bg-secondary: #F9FAFB;\n  --bg-tertiary: #F3F4F6;\n  --bg-gradient: linear-gradient(135deg, #EFF6FF 0%, #FFFFFF 50%, #F3E8FF 100%);\n  \n  /* Text Colors */\n  --text-primary: #111827;\n  --text-secondary: #6B7280;\n  --text-tertiary: #9CA3AF;\n  --text-accent: #374151;\n  \n  /* Border Colors */\n  --border-primary: #E5E7EB;\n  --border-secondary: #D1D5DB;\n  --border-tertiary: #F3F4F6;\n  \n  /* Accent Colors */\n  --accent-primary: #6366F1;\n  --accent-secondary: #8B5CF6;\n  --accent-gradient: linear-gradient(135deg, #6366F1, #8B5CF6);\n  \n  /* Shadow Colors */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  \n  /* Feature Colors */\n  --feature-bg: #EFF6FF;\n  --feature-icon-color: #6366F1;\n  \n  /* Error Colors */\n  --error-bg: #FEF2F2;\n  --error-border: #FECACA;\n  --error-text: #DC2626;\n  \n  /* Input Colors */\n  --input-bg: #FFFFFF;\n  --input-border: #D1D5DB;\n  --input-focus: #6366F1;\n  --input-focus-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n:root[data-theme=\"dark\"] {\n  /* Background Colors */\n  --bg-primary: #1F2937;\n  --bg-secondary: #111827;\n  --bg-tertiary: #374151;\n  --bg-gradient: linear-gradient(135deg, #1F2937 0%, #111827 50%, #374151 100%);\n  \n  /* Text Colors */\n  --text-primary: #F9FAFB;\n  --text-secondary: #D1D5DB;\n  --text-tertiary: #9CA3AF;\n  --text-accent: #E5E7EB;\n  \n  /* Border Colors */\n  --border-primary: #374151;\n  --border-secondary: #4B5563;\n  --border-tertiary: #6B7280;\n  \n  /* Accent Colors */\n  --accent-primary: #818CF8;\n  --accent-secondary: #A78BFA;\n  --accent-gradient: linear-gradient(135deg, #818CF8, #A78BFA);\n  \n  /* Shadow Colors */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.3);\n  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.3);\n  --shadow-xl: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  \n  /* Feature Colors */\n  --feature-bg: #374151;\n  --feature-icon-color: #818CF8;\n  \n  /* Error Colors */\n  --error-bg: #7F1D1D;\n  --error-border: #DC2626;\n  --error-text: #FCA5A5;\n  \n  /* Input Colors */\n  --input-bg: #374151;\n  --input-border: #4B5563;\n  --input-focus: #818CF8;\n  --input-focus-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2);\n}\n\n/* Theme Toggle Button */\n.theme-toggle {\n  padding: 10px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.theme-toggle:hover {\n  background: var(--bg-secondary);\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.theme-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* Homepage Styles */\n.homepage {\n  min-height: 100vh;\n  background: var(--bg-gradient);\n}\n\n.header {\n  background-color: var(--bg-primary);\n  box-shadow: var(--shadow-sm);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.header-content {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.logo-container {\n  width: 40px;\n  height: 40px;\n  background: var(--accent-gradient);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo-icon {\n  width: 24px;\n  height: 24px;\n  color: #FFFFFF;\n}\n\n.logo-title {\n  font-size: 20px;\n  font-weight: bold;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.logo-subtitle {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.main {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 64px 24px;\n}\n\n.hero-section {\n  text-align: center;\n  margin-bottom: 64px;\n}\n\n.hero-title {\n  font-size: 48px;\n  font-weight: bold;\n  color: var(--text-primary);\n  margin-bottom: 24px;\n  line-height: 1.1;\n}\n\n.hero-highlight {\n  background: var(--accent-gradient);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-subtitle {\n  font-size: 20px;\n  color: var(--text-secondary);\n  max-width: 768px;\n  margin: 0 auto 32px auto;\n  line-height: 1.6;\n}\n\n/* CTA Button */\n.cta-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--accent-gradient);\n  color: #FFFFFF;\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  box-shadow: var(--shadow-md);\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.cta-button:hover {\n  transform: scale(1.05);\n}\n\n.cta-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.cta-arrow {\n  width: 20px;\n  height: 20px;\n}\n\n/* Advisors Grid */\n.advisors-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  margin-bottom: 64px;\n}\n\n.advisor-card {\n  background-color: var(--bg-primary);\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-primary);\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.advisor-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-xl);\n}\n\n.advisor-card-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px auto;\n}\n\n.advisor-card-icon svg {\n  width: 32px;\n  height: 32px;\n}\n\n.advisor-card-title {\n  font-size: 24px;\n  font-weight: bold;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.advisor-card-role {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.advisor-card-description {\n  font-size: 16px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Features Section */\n.features-section {\n  margin-bottom: 64px;\n}\n\n.features-title {\n  font-size: 32px;\n  font-weight: bold;\n  color: var(--text-primary);\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n}\n\n.feature-card {\n  text-align: center;\n  padding: 24px;\n}\n\n.feature-icon {\n  width: 64px;\n  height: 64px;\n  background-color: var(--feature-bg);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px auto;\n}\n\n.feature-icon svg {\n  width: 32px;\n  height: 32px;\n  color: var(--feature-icon-color);\n}\n\n.feature-title {\n  font-size: 20px;\n  font-weight: bold;\n  color: var(--text-primary);\n  margin-bottom: 12px;\n}\n\n.feature-description {\n  font-size: 16px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Suggestions Panel */\n.suggestions-panel {\n  padding: 32px 0;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.suggestions-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.suggestions-title {\n  font-size: 28px;\n  font-weight: bold;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.suggestions-subtitle {\n  font-size: 16px;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.suggestions-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n}\n\n.suggestion-category {\n  background-color: var(--bg-primary);\n  border-radius: 12px;\n  border: 1px solid var(--border-primary);\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  transition: box-shadow 0.2s ease;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n}\n\n.suggestion-category:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.category-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.category-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.category-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.suggestion-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.suggestion-button {\n  text-align: left;\n  padding: 12px 16px;\n  border: 1px solid var(--border-secondary);\n  border-radius: 8px;\n  background-color: transparent;\n  color: var(--text-accent);\n  font-size: 14px;\n  line-height: 1.4;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.suggestion-button:hover {\n  background-color: var(--hover-bg, var(--bg-secondary));\n  border-color: var(--hover-border, var(--accent-primary));\n  color: var(--hover-text, var(--text-primary));\n  transform: translateY(-1px);\n}\n\n/* Message Components */\n.user-message-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n}\n\n.user-message {\n  background: var(--accent-gradient);\n  color: #FFFFFF;\n  border-radius: 16px;\n  padding: 12px 24px;\n  max-width: 384px;\n}\n\n.user-message p {\n  margin: 0;\n}\n\n.reply-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  padding: 4px 8px;\n  background-color: var(--bg-tertiary);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.advisor-message-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.advisor-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.advisor-avatar svg {\n  width: 20px;\n  height: 20px;\n}\n\n.advisor-message-bubble {\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid;\n  padding: 16px;\n  max-width: 512px;\n  transition: all 0.2s ease;\n}\n\n.advisor-message-bubble.clickable:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.advisor-message-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.advisor-message-name {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.reply-badge {\n  font-size: 10px;\n  background: var(--accent-primary);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-left: 4px;\n}\n\n.message-time {\n  font-size: 12px;\n}\n\n.advisor-message-text {\n  line-height: 1.6;\n}\n\n.advisor-message-text > div:last-child p:last-child {\n  margin-bottom: 0; /* Remove bottom margin from last paragraph */\n}\n\n.advisor-message-text strong {\n  font-weight: 600;\n}\n\n.advisor-message-text em {\n  font-style: italic;\n}\n\n.advisor-message-text ul,\n.advisor-message-text ol {\n  margin: 0.75rem 0;\n  padding-left: 1.5rem;\n}\n\n.advisor-message-text li {\n  margin-bottom: 0.25rem;\n}\n\n.advisor-message-text p {\n  margin-bottom: 0.75rem;\n}\n\n.advisor-message-text p:last-child {\n  margin-bottom: 0;\n}\n\n\n/* Updated Message Actions Styles */\n.message-actions {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-tertiary);\n}\n\n.message-action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.message-action-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: 1px solid;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.message-action-button:hover {\n  background: var(--bg-secondary);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.message-action-button:active {\n  transform: translateY(0);\n}\n\n.message-action-button svg {\n  width: 14px;\n  height: 14px;\n  color: inherit;\n}\n\n/* Tooltip Styles */\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 8px;\n  padding: 6px 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  opacity: 0;\n  animation: tooltipFadeIn 0.2s ease-out forwards;\n}\n\n.tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 4px solid transparent;\n  border-top-color: var(--border-secondary);\n}\n\n.tooltip::before {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: -1px;\n  border: 4px solid transparent;\n  border-top-color: var(--bg-primary);\n}\n\n/* Tooltip Animation */\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* Dark theme tooltip adjustments */\n[data-theme=\"dark\"] .tooltip {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n/* Focus states for accessibility */\n.message-action-button:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n/* Copy button success state */\n.message-action-button.copied {\n  color: #10B981 !important;\n  border-color: #10B98140 !important;\n}\n\n.reply-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: 1px solid;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.reply-button:hover {\n  background: var(--bg-secondary);\n}\n\n/* Error Messages */\n.error-message-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.error-message {\n  background-color: var(--error-bg);\n  border: 1px solid var(--error-border);\n  color: var(--error-text);\n  border-radius: 12px;\n  padding: 12px 16px;\n  max-width: 384px;\n}\n\n.error-message p {\n  margin: 0;\n}\n\n/* Thinking Indicators */\n.thinking-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n  opacity: 0.8;\n}\n\n.thinking-bubble {\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid;\n  padding: 16px;\n  max-width: 288px;\n}\n\n.thinking-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.advisor-name {\n  font-weight: 500;\n  font-size: 14px;\n  margin: 0;\n}\n\n.thinking-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary);\n  font-style: italic;\n  margin-bottom: 8px;\n}\n\n.thinking-dots {\n  display: flex;\n  gap: 4px;\n}\n\n.thinking-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  animation: bounce 1.4s ease-in-out infinite both;\n}\n\n.thinking-text {\n  font-size: 14px;\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n\n/* Basic Chat Input - SCOPED TO AVOID CONFLICTS */\n.input-area {\n  border-top: 1px solid var(--border-primary);\n  padding: 16px;\n}\n\n.input-container {\n  display: flex;\n  gap: 16px;\n}\n\n.message-input {\n  flex: 1;\n  resize: none;\n  border: 1px solid var(--input-border);\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.2s ease;\n  background-color: var(--input-bg);\n  color: var(--text-primary);\n}\n\n.message-input::placeholder {\n  color: var(--text-secondary);\n}\n\n.message-input:focus {\n  border-color: var(--input-focus);\n  box-shadow: var(--input-focus-shadow);\n}\n\n/* IMPORTANT: Make send button styles specific to basic ChatInput only */\n.input-container .send-button {\n  background: var(--accent-gradient);\n  color: #FFFFFF;\n  padding: 12px 24px;\n  border-radius: 12px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.input-container .send-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.input-container .send-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.input-container .send-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.input-container .send-text {\n  display: none;\n}\n\n/* Footer Styles */\n.footer {\n  background-color: var(--bg-primary);\n  border-top: 1px solid var(--border-primary);\n  margin-top: auto;\n}\n\n.footer-content {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 24px;\n  text-align: center;\n}\n\n.footer-text {\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin: 0;\n}\n\n.footer-neon-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n}\n\n.footer-neon-link:hover {\n  opacity: 0.8;\n}\n\n.footer-neon-logo {\n  height: 1em;\n  width: auto;\n  vertical-align: text-bottom;\n  margin-right: 2px;\n}\n\n.footer-patents-link {\n  color: var(--text-secondary);\n  text-decoration: underline;\n  transition: opacity 0.2s ease;\n}\n\n.footer-patents-link:hover {\n  opacity: 0.8;\n}\n\n.rag-info-overlay {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 1000;\n  width: 320px;\n  max-width: 90vw;\n  border: 1px solid;\n  border-radius: 8px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  margin-top: 8px;\n  backdrop-filter: blur(10px);\n  animation: ragOverlaySlideIn 0.2s ease-out;\n}\n\n@keyframes ragOverlaySlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.rag-overlay-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  font-weight: 600;\n  font-size: 14px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  border-radius: 8px 8px 0 0;\n}\n\n.rag-overlay-content {\n  padding: 16px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.rag-stat-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border-secondary);\n}\n\n.rag-stat-row:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.rag-stat-label {\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.rag-stat-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.rag-stat-value.positive {\n  color: #10B981;\n}\n\n.rag-stat-value.negative {\n  color: #6B7280;\n}\n\n.rag-documents-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-secondary);\n}\n\n.rag-section-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.rag-document-item {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 6px;\n  padding: 10px;\n  margin-bottom: 8px;\n}\n\n.rag-document-item:last-child {\n  margin-bottom: 0;\n}\n\n.rag-document-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rag-filename {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n  flex: 1;\n  margin-right: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rag-relevance {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--accent-color);\n  background: var(--accent-color)15;\n  padding: 2px 6px;\n  border-radius: 10px;\n  white-space: nowrap;\n}\n\n.rag-chunk-preview {\n  font-size: 11px;\n  line-height: 1.4;\n  color: var(--text-tertiary);\n  background: var(--bg-quaternary);\n  padding: 6px 8px;\n  border-radius: 4px;\n  border-left: 2px solid var(--accent-color);\n  margin-top: 6px;\n}\n\n.rag-no-documents {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: var(--bg-secondary);\n  border: 1px dashed var(--border-secondary);\n  border-radius: 6px;\n  color: var(--text-secondary);\n  font-size: 12px;\n  font-style: italic;\n  margin-top: 8px;\n}\n\n/* Accessibility improvements */\n.rag-info-overlay:focus-within {\n  outline: 2px solid var(--accent-color);\n  outline-offset: 2px;\n}\n\n/* Smooth transitions */\n.message-action-button {\n  transition: all 0.2s ease;\n}\n\n.message-action-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Custom scrollbar for overlay content */\n.rag-overlay-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.rag-overlay-content::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n  border-radius: 2px;\n}\n\n.rag-overlay-content::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 2px;\n}\n\n.rag-overlay-content::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary);\n}\n\n/* Dark theme adjustments */\n[data-theme=\"dark\"] .rag-info-overlay {\n  background: #1f2937;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);\n}\n\n[data-theme=\"dark\"] .rag-overlay-header {\n  background: #374151;\n}\n\n[data-theme=\"dark\"] .rag-document-item {\n  background: #374151;\n  border-color: #4B5563;\n}\n\n[data-theme=\"dark\"] .rag-chunk-preview {\n  background: #4B5563;\n  color: #D1D5DB;\n}\n\n[data-theme=\"dark\"] .rag-no-documents {\n  background: #374151;\n  border-color: #4B5563;\n}\n\n/* Animations */\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .suggestions-panel {\n    padding: 24px 16px;\n  }\n  \n  .suggestion-category {\n    padding: 18px;\n    min-height: 180px;\n  }\n}\n\n@media (max-width: 768px) {\n  .suggestions-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .suggestions-panel {\n    padding: 24px 16px;\n  }\n  \n  .suggestions-title {\n    font-size: 24px;\n  }\n  \n  .suggestion-category {\n    padding: 16px;\n    min-height: auto;\n  }\n  \n  .suggestion-button {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n\n  .advisor-message-text {\n    font-size: 14px;\n  }\n\n  /* Basic ChatInput mobile styles */\n  .input-container .send-text {\n    display: inline;\n  }\n\n  .hero-title {\n    font-size: 36px;\n  }\n\n  .hero-subtitle {\n    font-size: 18px;\n  }\n\n  .advisors-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n\n    .message-action-buttons {\n    gap: 6px;\n  }\n\n  .message-action-button {\n    width: 28px;\n    height: 28px;\n  }\n\n  .tooltip {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n\n  .rag-info-overlay {\n    width: 280px;\n    left: 0;\n    right: auto;\n  }\n  \n  .rag-document-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  \n  .rag-filename {\n    margin-right: 0;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: initial;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
